import { useEffect, useState } from 'react'
import { UserSettingsAlertSettings, UserSettingsAlertControls, UserSettingsWaterThresholds } from '../components'
import Switch from 'react-switch'

export function UserSettingsPage() {
  const [advancedMode, setAdvancedMode] = useState(false)

  useEffect(() => {
    const mode = localStorage.getItem('advancedMode')
    setAdvancedMode(mode === 'true')
  }, [])

  useEffect(() => {
    localStorage.setItem('advancedMode', String(advancedMode))
  }, [advancedMode])

  return (
    <div className={tailwind.container}>
      <div className="flex flex-row w-100% my-6 justify-between">
        <h2>User Settings</h2>
        <div className="flex flex-row w-100% mt-3">
          <div className="mt-0.5">Advanced Mode</div>
          <div className="mx-3">
            <Switch
              onChange={() => setAdvancedMode(!advancedMode)}
              checked={advancedMode}
              checkedIcon={false}
              uncheckedIcon={false}
            />
          </div>
        </div>
      </div>
      <UserSettingsAlertControls advancedMode={advancedMode} />
      <UserSettingsAlertSettings advancedMode={advancedMode} />
      <UserSettingsWaterThresholds />

      <div className="flex justify-end m-3">
        <button className={tailwind.buttonEnabled} onClick={() => {}}>
          Save
        </button>
      </div>
    </div>
  )
}

const tailwind = {
  container: 'mt-3 mx-3',
  buttonEnabled:
    'bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-4 rounded focus:outline-none focus:shadow-outline mb-1',
  buttonDisabled: 'bg-gray-400 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline mb-3',
}
